// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_1nw4m"};